import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@apollo/client';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { GetMarketplaceFilters } from '@atlassian/mpac-services-client';
import { removeAttributes } from '@atlassian/mpac-utils';
import { useMemo } from 'react';
import { ViewFilters } from '../../../Telemetry/tasks';
export const useFetchFilters = (allFilterDefinitions, setIsFiltersFetchPending) => {
  const {
    enableRunsOnAtlassian
  } = useStatsig();
  const isRunsOnAtlassianEnabled = enableRunsOnAtlassian();
  const {
    loading,
    error,
    data: filterOptionsData
  } = useQuery(GetMarketplaceFilters, {
    variables: {
      filterIds: allFilterDefinitions.map(filter => filter.filterId)
    },
    onCompleted: () => {
      setIsFiltersFetchPending(false);
    },
    onError: () => {
      setIsFiltersFetchPending(false);
    }
  });
  const getFilterById = (filters, filterId) => filters.find(filter => filter.filterId === filterId);

  // Generating the currentFilterState using useMemo
  // this state will be used to check the status of each filter
  const currentFilterState = useMemo(() => allFilterDefinitions.reduce((acc, item) => {
    var _getFilterById;
    if (loading) {
      ViewFilters.start();
      acc[item.filterId] = 'loading';
    } else if (error) {
      ViewFilters.failed(error);
      acc[item.filterId] = 'error';
    } else if (filterOptionsData !== null && filterOptionsData !== void 0 && filterOptionsData.marketplaceFilters && ((_getFilterById = getFilterById(filterOptionsData.marketplaceFilters, item.filterId)) === null || _getFilterById === void 0 ? void 0 : _getFilterById.__typename) === 'MarketplaceSearchFilterError') {
      ViewFilters.failed(new Error('No Filter Option Data'));
      acc[item.filterId] = 'error';
    } else {
      ViewFilters.succeeded();
      acc[item.filterId] = 'default';
    }
    return acc;
  }, {}), [allFilterDefinitions, loading, error, filterOptionsData]);
  const currentFilterOptions = useMemo(() => {
    if (!(filterOptionsData !== null && filterOptionsData !== void 0 && filterOptionsData.marketplaceFilters)) {
      return {};
    }
    const filters = filterOptionsData.marketplaceFilters;
    const options = filters.reduce((acc, filter) => {
      return _objectSpread(_objectSpread({}, acc), {}, {
        [filter.filterId]: filter.__typename === 'MarketplaceFilterOptions' ? filter.options : []
      });
    }, {});
    let newTrustOptions;
    if (!isRunsOnAtlassianEnabled) {
      var _options$trustSignals;
      newTrustOptions = (_options$trustSignals = options.trustSignals) === null || _options$trustSignals === void 0 ? void 0 : _options$trustSignals.filter(trustSignal => {
        if (trustSignal.id !== 'runsOnAtlassian') {
          return true;
        }
      });
      options.trustSignals = newTrustOptions;
    }
    return removeAttributes(options, ['__typename']);
  }, [filterOptionsData, isRunsOnAtlassianEnabled]);
  return {
    currentFilterOptions,
    currentFilterState
  };
};